/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import-helpers/order-imports */
/* eslint-disable no-unused-vars */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-confusing-arrow */
/* eslint-disable operator-linebreak */
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
  useContext,
} from 'react';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';
import { format, addHours, subHours } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import * as Yup from 'yup';

import AlertModal from '../../components/AlertModal';
import Notification from '../../components/Notification';
import TableManager from '../../components/TableManager';
import { AppContext } from '../../contexts/app';
import { useManager } from '../../hooks/manager';
import LayoutAdmin from '../../layouts/admin';
import api from '../../services/api';

const parseBackendDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return addHours(date, 3);
};

const toInputDate = (value) => {
  const date = parseBackendDate(value);
  if (!date) return '';
  return format(date, 'yyyy-MM-dd');
};

const formatDateBr = (value) => {
  const date = parseBackendDate(value);
  if (!date) return null;
  return format(date, 'dd/MM/yyyy', { locale: ptBR });
};

const formatDateTimeBr = (value) => {
  const date = parseBackendDate(value);
  if (!date) return null;
  return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR });
};

const formatInputDateBr = (value) => {
  if (!value) return null;
  const date = new Date(`${value}T12:00:00`);
  if (Number.isNaN(date.getTime())) return null;
  return format(date, 'dd/MM/yyyy', { locale: ptBR });
};

const PERIODO_APLICACAO_EXPLICACAO =
  'Deputados cadastrados dentro desse período recebem automaticamente o Início e o Término do Mandato informados neste formulário.';

const TOOLTIP_MANDATO_APLICADO_DE =
  `Data inicial do período de aplicação. ${PERIODO_APLICACAO_EXPLICACAO}`;

const TOOLTIP_MANDATO_APLICADO_ATE =
  `Data final do período de aplicação. ${PERIODO_APLICACAO_EXPLICACAO}`;

function PeriodosMandato() {
  const notificationRef = useRef();
  const confirmRef = useRef();
  const { setLoading } = useContext(AppContext);
  const [validationErrors, setValidationErrors] = useState({});
  const { load, store, update, destroy } = useManager();
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState();
  const [nome, setNome] = useState('');
  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [mandatoAplicadoDe, setMandatoAplicadoDe] = useState('');
  const [mandatoAplicadoAte, setMandatoAplicadoAte] = useState('');
  const [ativo, setAtivo] = useState(true);

  useEffect(() => {
    load('/periodos-mandato');
  }, [load]);

  const resetForm = useCallback(() => {
    setValidationErrors({});
    setId(undefined);
    setNome('');
    setDataInicial('');
    setDataFinal('');
    setMandatoAplicadoDe('');
    setMandatoAplicadoAte('');
    setAtivo(true);
  }, []);

  const handleCreate = useCallback(() => {
    resetForm();
    setShowModal(true);
  }, [resetForm]);

  const handleUpdate = useCallback((data) => {
    setValidationErrors({});
    setId(data.id);
    setNome(data.nome || '');
    setDataInicial(toInputDate(data.data_inicial));
    setDataFinal(toInputDate(data.data_final));
    setMandatoAplicadoDe(toInputDate(data.mandato_aplicado_de));
    setMandatoAplicadoAte(toInputDate(data.mandato_aplicado_ate));
    setAtivo(data.ativo !== false && data.ativo !== 0);
    setShowModal(true);
  }, []);

  const dateFormatter = useCallback((field) => (row) => {
    const formatted = formatDateBr(row[field]);
    return formatted ? <span>{formatted}</span> : <span />;
  }, []);

  const dateTimeFormatter = useCallback((field) => (row) => {
    const formatted = formatDateTimeBr(row[field]);
    return formatted ? <span>{formatted}</span> : <span />;
  }, []);
  
  const dateTimeFormatterByDate = useCallback((date) => {
    const formatted = formatDateTimeBr(date);
    return formatted ? <span>{formatted}</span> : <span />;
  }, [formatDateTimeBr]);

  const ativoFormatter = useCallback((row) => (
    row?.ativo
      ? <i className="fa-solid fa-circle-check text-success" />
      : <i className="fa-solid fa-circle-xmark text-danger" />
  ), []);

  const handleReaplicar = useCallback((row) => {
    const aplicadoDe = formatDateBr(row.mandato_aplicado_de);
    const aplicadoAte = formatDateBr(row.mandato_aplicado_ate);
    const mandatoDe = formatDateBr(row.data_inicial);
    const mandatoAte = formatDateBr(row.data_final);

    confirmRef.current.show({
      title: 'Reaplicar mandatos',
      message: `Esta ação irá sobrescrever o início e o término de mandato de todos os deputados cadastrados entre ${aplicadoDe} e ${aplicadoAte}, aplicando o Início do Mandato (${mandatoDe}) e o Término do Mandato (${mandatoAte}) configurados neste registro. Deseja continuar?`,
      confirmColor: 'warning',
      confirmText: 'Reaplicar',
      cancelText: 'Cancelar',
      cancelColor: 'link',
      onConfirm: async () => {
        try {
          setLoading(true);
          const res = await api.post(`/periodos-mandato/${row.id}/reaplicar`);
          confirmRef.current.close();
          load('/periodos-mandato');
          notificationRef.current?.notify({
            message: `Mandato reaplicado em ${res.data.updated} usuário(s).`,
          });
        } catch (error) {
          const message = error?.response?.data?.message
            || 'Não foi possível reaplicar o período de mandato.';
          notificationRef.current?.notify({
            message,
            color: 'danger',
          });
        } finally {
          setLoading(false);
        }
      },
    });
  }, [load, setLoading]);

  const actions = useMemo(() => [
    {
      name: 'reaplicar',
      tooltip: 'Reaplicar Início e Término do Mandato aos deputados cadastrados no período de aplicação',
      color: 'warning',
      className: (row) => (row?.mandato_aplicado_em ? 'mt-2 mr-2' : 'd-none'),
      icon: 'fa-solid fa-rotate-right',
      onClick: (row) => handleReaplicar(row),
    },
  ], [handleReaplicar]);

  const submitPeriodo = useCallback((payload) => {
    const onSuccess = () => {
      setShowModal(false);
      load('/periodos-mandato');
    };

    if (id) {
      update(id, '/periodos-mandato', payload, onSuccess);
    } else {
      store('/periodos-mandato', payload, onSuccess);
    }
  }, [id, store, update, load]);

  const handleSave = useCallback(() => {
    (async () => {
      try {
        const payload = {
          nome,
          data_inicial: dataInicial,
          data_final: dataFinal,
          mandato_aplicado_de: mandatoAplicadoDe,
          mandato_aplicado_ate: mandatoAplicadoAte,
          ativo,
        };

        const schema = Yup.object().shape({
          nome: Yup.string().required('Informe o nome do mandato'),
          data_inicial: Yup.string().required('Informe a data inicial'),
          data_final: Yup.string().required('Informe a data final'),
          mandato_aplicado_de: Yup.string().required('Informe a data "Aplicar de"'),
          mandato_aplicado_ate: Yup.string().required('Informe a data "Aplicar até"'),
        })
          .test('intervalo', 'A data final deve ser igual ou posterior à data inicial', (value) => {
            if (!value.data_inicial || !value.data_final) return true;
            return value.data_final >= value.data_inicial;
          })
          .test('aplicarIntervalo', '"Aplicar até" deve ser igual ou posterior a "Aplicar de"', (value) => {
            if (!value.mandato_aplicado_de || !value.mandato_aplicado_ate) return true;
            return value.mandato_aplicado_ate >= value.mandato_aplicado_de;
          });

        await schema.validate(payload, { abortEarly: false });

        const aplicadoDe = formatInputDateBr(mandatoAplicadoDe);
        const aplicadoAte = formatInputDateBr(mandatoAplicadoAte);
        const mandatoDe = formatInputDateBr(dataInicial);
        const mandatoAte = formatInputDateBr(dataFinal);

        confirmRef.current.show({
          title: 'Confirmar período de aplicação',
          message: `O período de aplicação vai de ${aplicadoDe} a ${aplicadoAte}. Deputados cadastrados nesse intervalo receberão automaticamente o Início do Mandato (${mandatoDe}) e o Término do Mandato (${mandatoAte}). Deseja salvar?`,
          confirmColor: 'success',
          confirmText: 'Salvar',
          cancelText: 'Cancelar',
          cancelColor: 'link',
          onConfirm: () => {
            confirmRef.current.close();
            submitPeriodo(payload);
          },
        });
      } catch (err) {
        setLoading(false);

        if (err.name === 'ValidationError') {
          const errors = {};
          err.inner.forEach((error) => {
            let field = error.path;
            if (error.path === 'intervalo') field = 'data_final';
            if (error.path === 'aplicarIntervalo') field = 'mandato_aplicado_ate';
            errors[field] = error.message;
          });
          setValidationErrors(errors);
        }
      }
    })();
  }, [
    nome,
    dataInicial,
    dataFinal,
    mandatoAplicadoDe,
    mandatoAplicadoAte,
    ativo,
    id,
    submitPeriodo,
    setLoading,
  ]);

  const columns = useMemo(() => [
    {
      dataField: 'nome',
      text: 'Nome do mandato',
      textFilter: true,
    },
    {
      dataField: 'criadoPor.name',
      text: 'Criado por',
      textFilter: true,
    },
    {
      dataField: 'data_inicial',
      text: 'Data inicial',
      formatter: dateFormatter('data_inicial'),
    },
    {
      dataField: 'data_final',
      text: 'Data final',
      formatter: dateFormatter('data_final'),
    },
    {
      dataField: 'mandato_aplicado_de',
      text: 'Aplicar de',
      formatter: dateFormatter('mandato_aplicado_de'),
    },
    {
      dataField: 'mandato_aplicado_ate',
      text: 'Aplicar até',
      formatter: dateFormatter('mandato_aplicado_ate'),
    },
    {
      dataField: 'ativo',
      text: 'Ativo',
      formatter: ativoFormatter,
    },
    {
      dataField: 'mandato_aplicado_em',
      text: 'Mandato aplicado em',
      formatter: (row) => row?.mandato_aplicado_em ? dateTimeFormatterByDate(subHours(new Date(row?.mandato_aplicado_em), 3)) : <span />,
    },
  ], [dateTimeFormatterByDate, dateFormatter, ativoFormatter]);

  return (
    <LayoutAdmin>
      <Notification ref={notificationRef} />
      <AlertModal ref={confirmRef} />
      <Container>
        <Row className="mt-5">
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h3>Período de Mandatos</h3>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Row>
                  <Col xs={12} sm={5} md={3} className="mb-3 mb-xl-0">
                    <Button block color="success" onClick={handleCreate}>
                      Cadastrar
                    </Button>
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <TableManager
              columns={columns}
              actions={actions}
              onUpdate={(row) => handleUpdate(row)}
              onDelete={(row) => destroy(row.id, '/periodos-mandato')}
            />
          </Col>
        </Row>
        <Modal
          isOpen={showModal}
          toggle={() => setShowModal(!showModal)}
          centered
        >
          <ModalHeader>
            <strong>Período de Mandatos</strong>
            <Button
              className="close position-absolute top-4 right-4 py-1 px-2"
              onClick={() => setShowModal(false)}
            >
              <i className="fas fa-times" />
            </Button>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label for="nome">Nome do mandato</Label>
                  <Input
                    id="nome"
                    type="text"
                    value={nome}
                    invalid={!!validationErrors.nome}
                    onChange={({ target: { value } }) => setNome(value)}
                  />
                  <FormFeedback>{validationErrors.nome}</FormFeedback>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup>
                  <Label for="data_inicial">Início do Mandato</Label>
                  <Input
                    id="data_inicial"
                    type="date"
                    value={dataInicial}
                    invalid={!!validationErrors.data_inicial}
                    onChange={({ target: { value } }) => {
                      setDataInicial(value);
                      setMandatoAplicadoDe(value);
                    }}
                  />
                  <FormFeedback>{validationErrors.data_inicial}</FormFeedback>
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup>
                  <Label for="data_final">Término do Mandato</Label>
                  <Input
                    id="data_final"
                    type="date"
                    value={dataFinal}
                    invalid={!!validationErrors.data_final}
                    onChange={({ target: { value } }) => setDataFinal(value)}
                  />
                  <FormFeedback>{validationErrors.data_final}</FormFeedback>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6}>
                <FormGroup>
                  <Label for="mandato_aplicado_de" className="d-flex align-items-center">
                    Data inicial da aplicação
                    <>
                      <i
                        id="tooltip-mandato-aplicado-de"
                        className="fa-solid fa-circle-question text-muted ml-2"
                        style={{ cursor: 'help' }}
                      />
                      <UncontrolledTooltip target="tooltip-mandato-aplicado-de">
                        {TOOLTIP_MANDATO_APLICADO_DE}
                      </UncontrolledTooltip>
                    </>
                  </Label>
                  <Input
                    id="mandato_aplicado_de"
                    type="date"
                    value={mandatoAplicadoDe}
                    invalid={!!validationErrors.mandato_aplicado_de}
                    onChange={({ target: { value } }) => setMandatoAplicadoDe(value)}
                  />
                  <FormFeedback>{validationErrors.mandato_aplicado_de}</FormFeedback>
                </FormGroup>
              </Col>
              <Col xs={12} md={6}>
                <FormGroup>
                  <Label for="mandato_aplicado_ate" className="d-flex align-items-center">
                    Data final da aplicação
                    <>
                      <i
                        id="tooltip-mandato-aplicado-ate"
                        className="fa-solid fa-circle-question text-muted ml-2"
                        style={{ cursor: 'help' }}
                      />
                      <UncontrolledTooltip target="tooltip-mandato-aplicado-ate">
                        {TOOLTIP_MANDATO_APLICADO_ATE}
                      </UncontrolledTooltip>
                    </>
                  </Label>
                  <Input
                    id="mandato_aplicado_ate"
                    type="date"
                    value={mandatoAplicadoAte}
                    invalid={!!validationErrors.mandato_aplicado_ate}
                    onChange={({ target: { value } }) => setMandatoAplicadoAte(value)}
                  />
                  <FormFeedback>{validationErrors.mandato_aplicado_ate}</FormFeedback>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={6} className="d-flex align-items-end">
                <FormGroup check>
                  <Input
                    type="checkbox"
                    checked={ativo}
                    onChange={() => setAtivo((prev) => !prev)}
                  />
                  <Label check>Ativo</Label>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button onClick={handleSave}>Salvar</Button>
          </ModalFooter>
        </Modal>
      </Container>
    </LayoutAdmin>
  );
}

export default PeriodosMandato;
